
import { useState } from 'react';

const services = [
  {
    id: 'crm',
    tag: 'CRM',
    fullTag: 'GESTÃO DE CLIENTES',
    title: 'CRM Completo para Empresas especializadas em Recursos de Multas',
    subtitle: 'Centralize toda sua operação em um único lugar',
    description: 'Chega de planilhas desorganizadas e informações perdidas. Nosso CRM foi desenvolvido especificamente para o mercado de recursos de multas, com campos personalizados para CNH, veículos, prazos de recursos e histórico completo de cada cliente.',
    features: [
      { text: 'Cadastro ilimitado de clientes e veículos', detail: 'Sem limite de cadastros, cresça sem preocupação' },
      { text: 'Histórico completo de atendimentos', detail: 'Todas as interações registradas automaticamente' },
      { text: 'Alertas de prazos e vencimentos', detail: 'Nunca mais perca um prazo de recurso' },
      { text: 'Relatórios de performance por cliente', detail: 'Saiba quais clientes geram mais receita' },
    ],
    metric: { value: '3x', label: 'mais clientes atendidos por dia' },
    image: 'https://readdy.ai/api/search-image?query=modern%20CRM%20customer%20relationship%20management%20dashboard%20interface%20on%20vertical%20screen%20showing%20client%20profiles%20contact%20lists%20task%20management%20and%20analytics%20professional%20business%20software%20with%20dark%20theme%20orange%20yellow%20accents%20clean%20organized%20layout&width=500&height=700&seq=service-crm-vertical-001&orientation=portrait',
    color: 'from-orange-500 to-amber-600',
    icon: 'ri-team-line',
  },
  {
    id: 'ia',
    tag: 'IA',
    fullTag: 'INTELIGÊNCIA ARTIFICIAL',
    title: 'Recursos de Multas com IA Avançada',
    subtitle: 'Aumente sua taxa de sucesso em até 40%',
    description: 'Nossa IA foi treinada com milhares de recursos deferidos e conhece todas as nuances da legislação de trânsito. Ela analisa cada infração e sugere a melhor estratégia de defesa, economizando horas do seu tempo.',
    features: [
      { text: 'Análise automática de infrações', detail: 'IA identifica irregularidades em segundos' },
      { text: 'Sugestão de argumentos jurídicos', detail: 'Baseado em casos de sucesso reais' },
      { text: 'Geração de petições completas', detail: 'Recursos personalizados, sem copiar e colar' },
      { text: 'Atualização constante da legislação', detail: 'Sempre em conformidade com as leis' },
      { text: 'Aprendizado contínuo', detail: 'IA melhora a cada recurso processado' },
    ],
    metric: { value: '40%', label: 'maior taxa de deferimento' },
    image: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20neural%20network%20visualization%20on%20vertical%20display%20showing%20glowing%20connections%20data%20processing%20nodes%20and%20AI%20brain%20concept%20futuristic%20technology%20with%20dark%20background%20orange%20yellow%20light%20trails%20digital%20innovation%20portrait%20format&width=500&height=700&seq=service-ia-vertical-001&orientation=portrait',
    color: 'from-amber-500 to-orange-600',
    icon: 'ri-robot-line',
  },
  {
    id: 'editais',
    tag: 'EDITAIS',
    fullTag: 'PROSPECÇÃO ATIVA',
    title: 'Editais Enriquecidos com Contatos',
    subtitle: 'Transforme editais públicos em oportunidades de negócio',
    description: 'Acesse editais de infrações de trânsito de todo o Brasil, já enriquecidos com dados de contato dos infratores. Prospecte ativamente e ofereça seus serviços para quem realmente precisa, no momento certo.',
    features: [
      { text: 'Editais de todo o Brasil', detail: 'Cobertura nacional de órgãos de trânsito' },
      { text: 'Dados de contato verificados', detail: 'Telefone, email e endereço atualizados' },
      { text: 'Filtros avançados de busca', detail: 'Por região, tipo de infração, valor' },
      { text: 'Exportação para campanhas', detail: 'Integre com WhatsApp e email marketing' },
      { text: 'Atualização diária', detail: 'Novos editais todos os dias' },
    ],
    metric: { value: '500+', label: 'novos leads por semana' },
    image: 'https://readdy.ai/api/search-image?query=business%20lead%20generation%20concept%20with%20vertical%20digital%20map%20of%20Brazil%20showing%20connection%20points%20data%20flow%20and%20location%20markers%20modern%20technology%20visualization%20dark%20background%20warm%20orange%20yellow%20highlights%20professional%20marketing%20portrait%20orientation&width=500&height=700&seq=service-editais-vertical-001&orientation=portrait',
    color: 'from-yellow-500 to-orange-500',
    icon: 'ri-file-search-line',
  },
  {
    id: 'rastreamento',
    tag: 'RASTREAMENTO',
    fullTag: 'RASTREAMENTO DE MULTAS',
    title: 'Monitoramento de Multas por Veículo e Frota',
    subtitle: 'Nunca mais seja pego de surpresa por uma multa',
    description: 'Acompanhe em tempo real todas as infrações de veículos individuais ou frotas inteiras. Receba alertas instantâneos quando novas multas são registradas e tenha controle total sobre prazos de defesa e pagamento.',
    features: [
      { text: 'Rastreamento por veículo individual', detail: 'Monitore cada veículo separadamente com histórico completo' },
      { text: 'Gestão completa de frotas', detail: 'Acompanhe dezenas ou centenas de veículos em um painel único' },
      { text: 'Alertas instantâneos de novas multas', detail: 'Notificações por email e SMS assim que uma infração é registrada' },
      { text: 'Controle de prazos de defesa', detail: 'Saiba exatamente quando cada recurso deve ser protocolado' },
      { text: 'Relatórios detalhados por período', detail: 'Análise de infrações por motorista, veículo ou tipo' },
      { text: 'Economia com multas evitadas', detail: 'Identifique padrões e reduza reincidências na frota' },
    ],
    metric: { value: '95%', label: 'das multas identificadas no prazo' },
    image: 'https://readdy.ai/api/search-image?query=fleet%20vehicle%20tracking%20management%20dashboard%20on%20vertical%20screen%20showing%20real%20time%20GPS%20monitoring%20map%20with%20multiple%20cars%20location%20pins%20route%20tracking%20and%20alert%20notifications%20modern%20interface%20dark%20background%20orange%20yellow%20accents%20professional%20logistics%20software%20portrait%20format&width=500&height=700&seq=service-rastreamento-vertical-001&orientation=portrait',
    color: 'from-yellow-500 to-amber-500',
    icon: 'ri-map-pin-line',
  },
  {
    id: 'automacao',
    tag: 'DOCUMENTOS',
    fullTag: 'AUTOMAÇÃO TOTAL',
    title: 'Documentos Gerados em Segundos',
    subtitle: 'Elimine o trabalho repetitivo da sua rotina',
    description: 'Contratos, procurações, requerimentos e petições gerados automaticamente com os dados do cliente. Basta um clique para ter documentos profissionais prontos para assinatura.',
    features: [
      { text: 'Preenchimento automático', detail: 'Dados puxados direto do CRM' },
      { text: 'Armazenamento em nuvem', detail: 'Documentos seguros e acessíveis' },
      { text: 'Versionamento automático', detail: 'Histórico de todas as alterações' },
    ],
    metric: { value: '85%', label: 'menos tempo em burocracia' },
    image: 'https://readdy.ai/api/search-image?query=digital%20document%20automation%20workflow%20on%20vertical%20display%20showing%20floating%20papers%20contracts%20forms%20and%20digital%20signatures%20modern%20office%20technology%20concept%20clean%20background%20with%20orange%20yellow%20accent%20elements%20professional%20business%20portrait%20orientation&width=500&height=700&seq=service-docs-vertical-001&orientation=portrait',
    color: 'from-orange-400 to-yellow-500',
    icon: 'ri-file-text-line',
  },
];

export default function DetailedServicesSection() {
  const [activeService, setActiveService] = useState(0);

  return (
    <section id="servicos-detalhados" className="py-12 md:py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-800 via-gray-900 to-gray-800"></div>
      
      {/* Animated Gradient Orbs */}
      <div className="absolute top-0 right-0 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-yellow-500/5 rounded-full blur-3xl animate-blob"></div>
      <div className="absolute bottom-0 left-0 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-amber-500/5 rounded-full blur-3xl animate-blob" style={{ animationDelay: '3s' }}></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-8 md:mb-16 scroll-animate">
          <span className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-orange-500/10 rounded-full mb-4 md:mb-6 border border-orange-500/20 backdrop-blur-sm">
            <i className="ri-tools-line text-orange-400 text-sm md:text-base"></i>
            <span className="text-xs md:text-sm font-semibold text-orange-400">CONHEÇA CADA FUNCIONALIDADE</span>
          </span>
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-2 md:mb-4">
            Ferramentas que Transformam Resultados
          </h2>
          <p className="text-sm md:text-xl text-gray-400 max-w-3xl mx-auto">
            Cada recurso foi pensado para resolver problemas reais do seu dia a dia
          </p>
        </div>

        {/* Service Navigation Tabs - Grid 3+2 on Mobile, 5 columns on Desktop */}
        <div className="mb-8 md:mb-16 scroll-animate">
          {/* Mobile Layout: 3 on top, 2 centered below */}
          <div className="flex flex-col gap-2 md:hidden">
            <div className="grid grid-cols-3 gap-2">
              {services.slice(0, 3).map((service, index) => (
                <button
                  key={service.id}
                  onClick={() => setActiveService(index)}
                  className={`relative flex flex-col items-center gap-2 p-3 rounded-xl font-medium transition-all duration-500 cursor-pointer overflow-hidden group ${
                    activeService === index
                      ? 'bg-gradient-to-br from-orange-500 to-amber-500 text-white shadow-lg shadow-orange-500/30 scale-105'
                      : 'bg-gray-800/50 backdrop-blur-sm text-gray-400 hover:bg-gray-800/80 hover:text-white border border-gray-700/50 hover:border-orange-500/30'
                  }`}
                >
                  <div className={`absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 ${activeService === index ? 'opacity-100' : 'group-hover:opacity-50'} transition-opacity duration-500`}></div>
                  <div className={`relative w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-300 ${
                    activeService === index ? 'bg-white/20' : 'bg-gray-700/50 group-hover:bg-orange-500/20'
                  }`}>
                    <i className={`${service.icon} text-lg ${activeService === index ? 'text-white' : 'text-orange-400'}`}></i>
                  </div>
                  <span className="text-[10px] font-semibold whitespace-nowrap relative z-10">{service.tag}</span>
                </button>
              ))}
            </div>
            <div className="flex justify-center gap-2">
              {services.slice(3, 5).map((service, index) => (
                <button
                  key={service.id}
                  onClick={() => setActiveService(index + 3)}
                  className={`relative flex flex-col items-center gap-2 p-3 rounded-xl font-medium transition-all duration-500 cursor-pointer overflow-hidden group w-[calc(33.333%-4px)] ${
                    activeService === index + 3
                      ? 'bg-gradient-to-br from-orange-500 to-amber-500 text-white shadow-lg shadow-orange-500/30 scale-105'
                      : 'bg-gray-800/50 backdrop-blur-sm text-gray-400 hover:bg-gray-800/80 hover:text-white border border-gray-700/50 hover:border-orange-500/30'
                  }`}
                >
                  <div className={`absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 ${activeService === index + 3 ? 'opacity-100' : 'group-hover:opacity-50'} transition-opacity duration-500`}></div>
                  <div className={`relative w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-300 ${
                    activeService === index + 3 ? 'bg-white/20' : 'bg-gray-700/50 group-hover:bg-orange-500/20'
                  }`}>
                    <i className={`${service.icon} text-lg ${activeService === index + 3 ? 'text-white' : 'text-orange-400'}`}></i>
                  </div>
                  <span className="text-[10px] font-semibold whitespace-nowrap relative z-10">{service.tag}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Desktop Layout: 5 columns */}
          <div className="hidden md:grid md:grid-cols-5 gap-4">
            {services.map((service, index) => (
              <button
                key={service.id}
                onClick={() => setActiveService(index)}
                className={`relative flex flex-col items-center gap-3 p-5 rounded-2xl font-medium transition-all duration-500 cursor-pointer overflow-hidden group ${
                  activeService === index
                    ? 'bg-gradient-to-br from-orange-500 to-amber-500 text-white shadow-lg shadow-orange-500/30 scale-105'
                    : 'bg-gray-800/50 backdrop-blur-sm text-gray-400 hover:bg-gray-800/80 hover:text-white border border-gray-700/50 hover:border-orange-500/30'
                }`}
              >
                <div className={`absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 ${activeService === index ? 'opacity-100' : 'group-hover:opacity-50'} transition-opacity duration-500`}></div>
                <div className={`relative w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 ${
                  activeService === index ? 'bg-white/20' : 'bg-gray-700/50 group-hover:bg-orange-500/20'
                }`}>
                  <i className={`${service.icon} text-2xl ${activeService === index ? 'text-white' : 'text-orange-400'}`}></i>
                </div>
                <span className="text-sm font-semibold whitespace-nowrap relative z-10">{service.tag}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Active Service Detail */}
        {services.map((service, index) => (
          <div
            key={service.id}
            className={`transition-all duration-500 ${
              activeService === index ? 'opacity-100' : 'hidden opacity-0'
            }`}
          >
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-start">
              {/* Content Side */}
              <div className="order-2 lg:order-1 flex flex-col justify-between scroll-animate-left">
                <div>
                  <span className={`inline-block px-2 md:px-3 py-0.5 md:py-1 bg-gradient-to-r ${service.color} text-white rounded-full text-[10px] md:text-xs font-semibold mb-2 md:mb-4`}>
                    {service.fullTag}
                  </span>
                  <h3 className="text-xl md:text-4xl font-bold text-white mb-2 md:mb-3 leading-tight">{service.title}</h3>
                  <p className="text-sm md:text-xl text-orange-400 font-medium mb-3 md:mb-6">{service.subtitle}</p>
                  <p className="text-sm md:text-lg text-gray-400 leading-relaxed mb-4 md:mb-8">{service.description}</p>

                  {/* Features List */}
                  <div className="space-y-2 md:space-y-4 mb-6 md:mb-8">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2 md:gap-4 group/feature">
                        <div className={`w-6 md:w-8 h-6 md:h-8 rounded-lg bg-gradient-to-br ${service.color} flex items-center justify-center flex-shrink-0 mt-0.5 transition-all duration-300 group-hover/feature:scale-110 group-hover/feature:shadow-lg`}>
                          <i className="ri-check-line text-white text-sm md:text-lg"></i>
                        </div>
                        <div>
                          <p className="font-semibold text-white text-sm md:text-base group-hover/feature:text-yellow-400 transition-colors duration-300">{feature.text}</p>
                          <p className="text-xs md:text-sm text-gray-500">{feature.detail}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Metric Highlight */}
                <div className={`inline-flex items-center gap-2 md:gap-4 px-4 md:px-6 py-3 md:py-4 bg-gradient-to-r ${service.color} rounded-xl md:rounded-2xl self-start relative overflow-hidden group/metric`}>
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover/metric:translate-x-full transition-transform duration-700"></div>
                  <span className="text-2xl md:text-4xl font-bold text-white relative z-10">{service.metric.value}</span>
                  <span className="text-white/90 font-medium text-xs md:text-base relative z-10">{service.metric.label}</span>
                </div>
              </div>

              {/* Image Side */}
              <div className="order-1 lg:order-2 flex items-start justify-center scroll-animate-right">
                <div className="relative w-full max-w-[280px] md:max-w-md group">
                  {/* Glow Effect */}
                  <div className={`absolute -inset-2 md:-inset-4 bg-gradient-to-r ${service.color} rounded-2xl md:rounded-3xl opacity-20 blur-xl md:blur-2xl group-hover:opacity-40 transition-opacity duration-500`}></div>
                  
                  {/* Image Container */}
                  <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-2xl border border-gray-700/50 group-hover:border-orange-500/30 transition-all duration-500">
                    <div className="w-full" style={{ aspectRatio: '5/7' }}>
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                    </div>
                    
                    {/* Overlay Gradient */}
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </div>

                  {/* Floating Badge */}
                  <div className="absolute -bottom-2 md:-bottom-4 -right-2 md:-right-4 bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl md:rounded-2xl p-2 md:p-4 border border-gray-700/50 shadow-xl">
                    <div className="flex items-center gap-2 md:gap-3">
                      <div className={`w-8 md:w-10 h-8 md:h-10 bg-gradient-to-br ${service.color} rounded-lg md:rounded-xl flex items-center justify-center`}>
                        <i className={`${service.icon} text-white text-base md:text-xl`}></i>
                      </div>
                      <div>
                        <p className="text-[10px] md:text-xs text-gray-400">Ativo</p>
                        <p className="text-xs md:text-sm font-bold text-white">{service.tag}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
